import { colorsPalettes, mixins } from "@similarweb/styles";
import { Title } from "@similarweb/ui-components";
import { FlexRowFlexEnd } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const MODAL_CUSTOM_STYLES = {
    content: {
        width: "475px",
        padding: "24px",
    },
};

export const ModalTitle = styled.div`
    ${mixins.setFontVariant("subsectionTitle", colorsPalettes.carbon[500])};
`;

export const ModalSubtitle = styled(Title)`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon[400])};

    line-height: 24px;
    margin-top: 32px;
`;

export const ButtonsContainer = styled(FlexRowFlexEnd)`
    gap: 8px;
    margin-top: 32px;
`;
